module.exports = __webpack_public_path__ + "static/media/image-3.7fa97f1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/FBGroup/image-3.png
// module id = 461
// module chunks = 0